import httpService from "./HttpService";

export async function restLogin(username, password) {
  return httpService.post('auth/login', {username: username, password: password}, null);
}
